'use client'

import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'

export const SandboxDatabaseCard = () => {
    const { t } = useTranslation('processors')

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('databaseIntegration')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    <div className="rounded-lg bg-gray-50 p-4">
                        <h4 className="mb-2 text-sm font-medium text-gray-700">
                            {t('transactionStorage')}
                        </h4>
                        <p className="text-sm text-gray-600">
                            {t('sandboxTransactionStorageDescription')}
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="text-center p-4 rounded-lg bg-blue-50">
                            <div className="text-2xl font-semibold text-gray-900">∞</div>
                            <div className="text-sm text-gray-600">{t('transactionLimit')}</div>
                            <div className="text-xs text-gray-500">{t('unlimitedTesting')}</div>
                        </div>
                        <div className="text-center p-4 rounded-lg bg-green-50">
                            <div className="text-2xl font-semibold text-gray-900">$0</div>
                            <div className="text-sm text-gray-600">{t('processingCost')}</div>
                            <div className="text-xs text-gray-500">{t('alwaysFree')}</div>
                        </div>
                        <div className="text-center p-4 rounded-lg bg-purple-50">
                            <div className="text-2xl font-semibold text-gray-900">100%</div>
                            <div className="text-sm text-gray-600">{t('reliability')}</div>
                            <div className="text-xs text-gray-500">{t('noExternalDependencies')}</div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

